/* PHAI — evento "Added to Cart" para o Klaviyo
 * Versão 2 — 09/09/2026
 *
 * O que mudou em relação à versão anterior:
 *  - Título, preço e imagem passam a vir do carrinho real da Shopify (/cart.js),
 *    e não mais de querySelector no DOM. A versão antiga lia o título de
 *    `document.querySelector('a.link')`, que é o primeiro link do cabeçalho,
 *    e a imagem de um seletor tão largo que pegava a primeira imagem da página.
 *  - CheckoutURL passa a ser um permalink de carrinho, que remonta o carrinho
 *    em qualquer dispositivo. Antes era ORIGIN + '/checkout', que abre vazio
 *    para quem clica no e-mail em outro aparelho.
 *  - O evento passa a levar um array `Items`, para montar o bloco de produto
 *    com imagem dentro do e-mail.
 *  - O clique é capturado por delegação no document, então funciona também na
 *    barra fixa do mobile, no quick add da coleção e depois de transição de página.
 */

(function () {
  'use strict';

  var ORIGIN = window.location.origin;
  var MAX_TENTATIVAS = 14; // ~4,2s esperando o carrinho atualizar
  var INTERVALO_MS = 300;
  var IMG_WIDTH = 600; // largura boa para e-mail

  var enviando = {}; // trava simples contra clique duplo

  function log() {
    if (window.PHAI_KLAVIYO_DEBUG) {
      console.log.apply(console, ['[PHAI/Klaviyo]'].concat([].slice.call(arguments)));
    }
  }

  function brl(centavos) {
    var v = (Number(centavos) || 0) / 100;
    try {
      return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (e) {
      return 'R$ ' + v.toFixed(2).replace('.', ',');
    }
  }

  function absoluta(url) {
    if (!url) return '';
    if (url.slice(0, 2) === '//') return 'https:' + url;
    if (url.slice(0, 4) === 'http') return url;
    return ORIGIN + url;
  }

  function imagem(url, largura) {
    var u = absoluta(url);
    if (!u) return '';
    if (u.indexOf('cdn.shopify.com') === -1) return u;
    return u.split('?')[0] + '?width=' + (largura || IMG_WIDTH);
  }

  // Permalink que remonta o carrinho inteiro em qualquer dispositivo:
  // https://phai.design/cart/44444:1,55555:2
  function permalinkDoCarrinho(cart) {
    var partes = (cart.items || []).map(function (i) {
      return (i.variant_id || i.id) + ':' + i.quantity;
    });
    if (!partes.length) return ORIGIN + '/cart';
    return ORIGIN + '/cart/' + partes.join(',');
  }

  function variantIdDoBotao(btn) {
    var form = btn.closest('form');
    if (!form) return null;
    var input = form.querySelector('[name="id"]:not([disabled])');
    return input && input.value ? String(input.value) : null;
  }

  function klaviyoPronto() {
    return typeof window.klaviyo !== 'undefined' && typeof window.klaviyo.track === 'function';
  }

  function montarItem(i) {
    return {
      ProductName: i.product_title || i.title || '',
      VariantName: i.variant_title || '',
      ProductID: i.product_id || '',
      VariantID: i.variant_id || i.id || '',
      SKU: i.sku || '',
      Quantity: i.quantity || 1,
      Price: brl(i.price),
      PriceCents: i.price || 0,
      ImageURL: imagem(i.image, IMG_WIDTH),
      URL: absoluta(i.url)
    };
  }

  function enviar(item, cart) {
    if (!klaviyoPronto()) {
      log('klaviyo ainda não carregou, tentando de novo em 500ms');
      return setTimeout(function () { enviar(item, cart); }, 500);
    }

    var itens = (cart.items || []).map(montarItem);
    var principal = montarItem(item);

    var payload = {
      // Nomes mantidos iguais aos da versão antiga, para não quebrar os
      // templates que já existem nos dois fluxos de recuperação.
      AddedItemProductName: principal.ProductName,
      AddedItemProductID: principal.ProductID,
      AddedItemVariantID: principal.VariantID,
      AddedItemImageURL: principal.ImageURL,
      AddedItemURL: principal.URL,
      AddedItemPrice: principal.Price,
      AddedItemPriceCents: principal.PriceCents,
      AddedItemQuantity: principal.Quantity,
      AddedItemVariantName: principal.VariantName,

      CheckoutURL: permalinkDoCarrinho(cart),

      CartTotal: brl(cart.total_price),
      CartTotalCents: cart.total_price || 0,
      CartItemCount: cart.item_count || 0,

      // Use este array no e-mail para listar os produtos com imagem.
      Items: itens,
      ItemNames: itens.map(function (x) { return x.ProductName; }),

      $value: (cart.total_price || 0) / 100
    };

    try {
      window.klaviyo.track('Added to Cart', payload);
      log('evento enviado', payload);
    } catch (e) {
      log('falha ao enviar', e);
    }
  }

  function esperarCarrinho(variantId, tentativa) {
    tentativa = tentativa || 0;

    fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = null;

        if (variantId && cart.items) {
          for (var i = cart.items.length - 1; i >= 0; i--) {
            if (String(cart.items[i].variant_id || cart.items[i].id) === variantId) {
              item = cart.items[i];
              break;
            }
          }
        }

        if (!item) {
          if (tentativa < MAX_TENTATIVAS) {
            return setTimeout(function () {
              esperarCarrinho(variantId, tentativa + 1);
            }, INTERVALO_MS);
          }
          // Último recurso: usa o item mais recente do carrinho.
          if (cart.items && cart.items.length) {
            item = cart.items[cart.items.length - 1];
          } else {
            log('carrinho vazio depois do clique, nada enviado');
            delete enviando[variantId];
            return;
          }
        }

        delete enviando[variantId];
        enviar(item, cart);
      })
      .catch(function (e) {
        if (tentativa < MAX_TENTATIVAS) {
          return setTimeout(function () {
            esperarCarrinho(variantId, tentativa + 1);
          }, INTERVALO_MS);
        }
        delete enviando[variantId];
        log('falha ao ler /cart.js', e);
      });
  }

  // Delegação: pega o botão real de adicionar ao carrinho em qualquer lugar da
  // loja. A barra fixa do mobile encaminha o clique para esse mesmo botão, então
  // o evento dispara uma vez só.
  document.addEventListener(
    'click',
    function (ev) {
      var btn = ev.target && ev.target.closest && ev.target.closest('button[name="add"]');
      if (!btn || btn.disabled) return;

      var variantId = variantIdDoBotao(btn) || 'desconhecido';
      if (enviando[variantId]) return;
      enviando[variantId] = true;
      setTimeout(function () { delete enviando[variantId]; }, 5000);

      log('clique em adicionar ao carrinho, variante', variantId);
      setTimeout(function () { esperarCarrinho(variantId, 0); }, 250);
    },
    true
  );

  log('tracking v2 carregado');
})();
